import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { FaSpinner } from "react-icons/fa";
import location_icon from "../../../Assets/Images/Contact/location_icon.webp";

const GetInTouchSection = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    message: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    try {
      setLoading(true);
      const resp = await axios.post(
        `${process.env.REACT_APP_API_URL}/contacts/create`,
        formData
      );
      if (resp) {
        toast.success(
          "Thanks for reaching out! Our team will contact you shortly.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: "linear-gradient(135deg, #050733, #CD1B1B)",
              color: "#FFFFFF",
              fontWeight: "500",
              fontFamily: "'Poppins', sans-serif",
              border: "1px solid #F53A5F40",
              borderRadius: "12px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.4)",
            },
            icon: "🚀",
          }
        );
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNo: "",
          message: "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full mb-12 relative min-h-[80vh] py-16 font-heading flex flex-col gap-6 px-4 md:px-8 lg:px-12 bg-[#0B0D14] bg-[radial-gradient(circle_at_85%_50%,#F53A5F40,transparent_20%)] backdrop-blur-lg border border-gray-100/20">
      <div className="absolute inset-0 bg-gradient-to-r -z-[1] blur-lg bg-black/40"></div>

      {/* Map and Form Container */}
      <div className="flex flex-col lg:flex-row items-stretch gap-6">
        {/* Map */}
        <div className="w-full lg:w-1/2 flex-1 rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3141.324513955502!2d-84.05952219999999!3d34.0734742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5971e2e83e6cb%3A0xa61fa51b1b92b41e!2s4285%20Brogdon%20Exchange%20NE%2C%20Suwanee%2C%20GA%2030024%2C%20USA!5e1!3m2!1sen!2sin!4v1758519188899!5m2!1sen!2sin"
            title="map"
            className="w-full h-full min-h-[500px]"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Form */}
        <div className="w-full lg:w-1/2 flex-1 h-full flex justify-center">
          <form
            onSubmit={handleSubmit}
            className="text-white p-8 md:p-10 rounded-2xl bg-gray-600 bg-opacity-10 backdrop-blur-sm shadow-2xl w-full"
          >
            <h2 className="text-4xl md:text-5xl font-heading uppercase font-bold mb-4">
              Contact Us
            </h2>
            <p className="text-[#F2F2F2] font-normal mb-6">
              Please fill your requirements. We will get back to you.
            </p>

            <div className="flex flex-col w-full sm:flex-row gap-4 mb-4">
              <input
                type="text"
                name="firstName"
                required
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                className="flex-1 p-3 rounded-md w-full bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
              />

              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                required
                value={formData.lastName}
                onChange={handleChange}
                className="flex-1 p-3 rounded-md w-full bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
              />
            </div>

            <input
              type="email"
              name="email"
              required
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 mb-4 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
            />
            <input
              type="text"
              name="mobileNo"
              required
              placeholder="Mobile No"
              value={formData.mobileNo}
              onChange={handleChange}
              className="w-full p-3 mb-4 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
            />

            <div className="relative w-full mb-4">
              <textarea
                name="message"
                required
                value={formData.message}
                onChange={handleChange}
                rows={3}
                className="w-full p-3 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 flex items-center justify-center outline-none text-white transition resize-none"
              />
              {!formData.message && (
                <span className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400 pointer-events-none">
                  Message here
                </span>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full p-3 rounded-md font-semibold text-white bg-red-600 hover:bg-red-700 active:bg-red-800 
               transition transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg outline-none  ${
                 loading ? "opacity-70 cursor-not-allowed" : ""
               }`}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <FaSpinner className="animate-spin text-white text-lg" />
                  <span>Submitting...</span>
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Location Details Below Map */}
      <div className="mt-8 p-6 bg-white/10 backdrop-blur-sm rounded-lg border border-gray-200/20">
        <div className="flex items-center justify-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
            <img src={location_icon} alt="location" className="w-5 h-5" />
          </div>
          <p className="text-white text-lg">
            <span className="font-semibold">Visit Us:</span> 4285 Brogdon
            Exchange NW, Suwanee, GA 30024
          </p>
        </div>
      </div>
    </section>
  );
};

export default GetInTouchSection;

// import axios from "axios";
// import React, { useState } from "react";
// import toast from "react-hot-toast";
// import { FaSpinner } from "react-icons/fa";

// const GetInTouchSection = () => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     mobileNo: "",
//     message: "",
//   });

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("Form Data:", formData);
//     try {
//       setLoading(true);
//       const resp = await axios.post(
//         `${process.env.REACT_APP_API_URL}/contacts/create`,
//         formData
//       );
//       if (resp) {
//         toast.success(
//           "Thanks for reaching out! Our team will contact you shortly.",
//           {
//             position: "top-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             style: {
//               background: "linear-gradient(135deg, #050733, #CD1B1B)",
//               color: "#FFFFFF",
//               fontWeight: "500",
//               fontFamily: "'Poppins', sans-serif",
//               border: "1px solid #F53A5F40",
//               borderRadius: "12px",
//               boxShadow: "0 4px 15px rgba(0,0,0,0.4)",
//             },
//             icon: "🚀",
//           }
//         );
//         setFormData({
//           firstName: "",
//           lastName: "",
//           email: "",
//           mobileNo: "",
//           message: "",
//         });
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="w-full mb-12 relative min-h-[80vh] py-16 font-heading flex flex-col lg:flex-row items-stretch gap-6 px-4 md:px-8 lg:px-12 bg-[#0B0D14] bg-[radial-gradient(circle_at_85%_50%,#F53A5F40,transparent_20%)] backdrop-blur-lg border border-gray-100/20">
//       <div className="absolute inset-0 bg-gradient-to-r -z-[1] blur-lg bg-black/40"></div>

//       {/* Map */}
//       <div className="w-full lg:w-1/2 flex-1 rounded-lg overflow-hidden">
//         <iframe
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3141.324513955502!2d-84.05952219999999!3d34.0734742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5971e2e83e6cb%3A0xa61fa51b1b92b41e!2s4285%20Brogdon%20Exchange%20NE%2C%20Suwanee%2C%20GA%2030024%2C%20USA!5e1!3m2!1sen!2sin!4v1758519188899!5m2!1sen!2sin"
//           title="map"
//           className="w-full h-full min-h-[500px]"
//           style={{ border: 0 }}
//           allowFullScreen=""
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//         ></iframe>
//       </div>

//       {/* Form */}
//       <div className="w-full lg:w-1/2 flex-1 h-full flex justify-center">
//         <form
//           onSubmit={handleSubmit}
//           className="text-white p-8 md:p-10 rounded-2xl bg-gray-600 bg-opacity-10 backdrop-blur-sm shadow-2xl w-full"
//         >
//           <h2 className="text-4xl md:text-5xl font-heading uppercase font-bold mb-4">
//             Contact Us
//           </h2>
//           <p className="text-[#F2F2F2] font-normal mb-6">
//             Please fill your requirements. We will get back to you.
//           </p>

//           <div className="flex flex-col w-full sm:flex-row gap-4 mb-4">
//             <input
//               type="text"
//               name="lastName"
//               placeholder="Last Name"
//               required
//               value={formData.lastName}
//               onChange={handleChange}
//               className="flex-1 p-3 rounded-md w-full bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
//             />
//             <input
//               type="text"
//               name="firstName"
//               required
//               placeholder="First Name"
//               value={formData.firstName}
//               onChange={handleChange}
//               className="flex-1 p-3 rounded-md w-full bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
//             />
//           </div>

//           <input
//             type="email"
//             name="email"
//             required
//             placeholder="Email"
//             value={formData.email}
//             onChange={handleChange}
//             className="w-full p-3 mb-4 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
//           />
//           <input
//             type="text"
//             name="mobileNo"
//             required
//             placeholder="Mobile No"
//             value={formData.mobileNo}
//             onChange={handleChange}
//             className="w-full p-3 mb-4 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 outline-none text-white placeholder-gray-400 transition"
//           />

//           <div className="relative w-full mb-4">
//             <textarea
//               name="message"
//               required
//               value={formData.message}
//               onChange={handleChange}
//               rows={3}
//               className="w-full p-3 rounded-md bg-transparent backdrop-blur-lg border border-gray-100/20 flex items-center justify-center outline-none text-white transition resize-none"
//             />
//             {!formData.message && (
//               <span className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-400 pointer-events-none">
//                 Message here
//               </span>
//             )}
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className={`w-full p-3 rounded-md font-semibold text-white bg-red-600 hover:bg-red-700 active:bg-red-800
//              transition transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg outline-none  ${
//                loading ? "opacity-70 cursor-not-allowed" : ""
//              }`}
//           >
//             {loading ? (
//               <div className="flex items-center justify-center gap-2">
//                 <FaSpinner className="animate-spin text-white text-lg" />
//                 <span>Submitting...</span>
//               </div>
//             ) : (
//               "Submit"
//             )}
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default GetInTouchSection;
